import CryptoJS from 'crypto-js';

export const encryptPassword = (password) => {
  let rkEncryptionKey = CryptoJS.enc.Base64.parse("u/Gu5posvwDsXUnV5Zaq4g==")
  let rkEncryptionIv = CryptoJS.enc.Base64.parse("5D9r9ZVzEYYgha93/aUK2w==")
  let utf8Stringified = CryptoJS.enc.Utf8.parse(password)
  let encrypted = CryptoJS.AES.encrypt(
    utf8Stringified.toString(),
    rkEncryptionKey, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: rkEncryptionIv
  }
  )
  let encryptedPassword = encrypted.ciphertext.toString(CryptoJS.enc.Base64)
  return encryptedPassword;
}
